import { Component } from '@angular/core';
import { PageComponent } from '@shared/lib/components/page.component';

@Component({
  selector: 'u-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: false,
})
export class PageNotFoundComponent extends PageComponent {
  src = 'page-not-found';

  protected defaultComponentData() {
    this.data = {
      page_title: '',
    };
    this.dataIsLoaded = true;
  }
}
